<template>
  <span>
    <strong
      class="capitalize cursor-pointer block outline-none"
      :name="`loan-details-tippy-${loan.id}-${anotherKey}`"
    >
      {{ loan.amount | currency }}
    </strong>
    <div class="tooltip-content">
      <TippyContent :to="`loan-details-tippy-${loan.id}-${anotherKey}`">
        <div class="p-2">
          <div class="flex justify-between">
            <p class="mr-3 text-gray-600">{{ $t('text.loanAmount') }}</p>
            <p class="font-medium">{{ loan.amount | currency }}</p>
          </div>
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.loanAmountRate') }}</p>
            <p class="font-medium">{{ loan.rateAmount | currency }}</p>
          </div>
          <div class="flex justify-between mt-3 mb-3">
            <p class="mr-3 text-gray-600">{{ $t('text.loanAmountIncreaseRate') }}</p>
            <p class="font-medium">{{ loan.increaseRateAmount | currency }}</p>
          </div>
          <hr />
          <template v-if="loan.status === 'PAID'">
            <div class="flex justify-between mt-3 mb-3">
              <p class="mr-3 text-gray-600">{{ $t('text.loanAmountPaid') }}</p>
              <p class="font-medium">{{ loan.paidAmount | currency }}</p>
            </div>
          </template>
          <template v-else>
            <div class="flex justify-between mt-3">
              <p class="mr-3 text-gray-600">{{ $t('text.loanAmountPay') }}</p>
              <p class="font-medium">{{ loan.payAmount | currency }}</p>
            </div>
            <div class="flex justify-between mt-3 mb-3">
              <p class="mr-3 text-gray-600">{{ $t('text.loanAmountExtension') }}</p>
              <p class="font-medium">{{ loan.extendAmount | currency }}</p>
            </div>
          </template>
          <hr />
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.loanDate') }}</p>
            <p class="text-gray-600">{{ loan.startDate }}</p>
          </div>
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.loanDateRepayment') }}</p>
            <p class="text-gray-600">{{ loan.endDate }}</p>
          </div>
          <div v-if="loan.status === 'PAID'" class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.loanDatePaid') }}</p>
            <p class="text-gray-600">{{ loan.paidDate }}</p>
          </div>
          <Button
            :to="{ name: 'LoanDetails', params: { loanId: loan.id } }"
            class="mt-3 w-full border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
          >
            {{ $t('text.seeMore') }}
          </Button>
        </div>
      </TippyContent>
    </div>
  </span>
</template>

<script>
import TippyContent from '@/components/ui/TippyContent';
import Button from '@/components/ui/button/Button';

export default {
  props: {
    loan: Object,
    anotherKey: Number,
  },
  components: {
    TippyContent,
    Button,
  },
};
</script>
